export interface EquipamientoProcesamiento {
  id: number;
  tipo_equipamiento_procesamiento_id: number;
  tipo_movilidad_id: number;
  marca: string;
  modelo: string;
  n_precinto: string;
  gps: string;
  tipo_equipamiento_procesamiento_nombre: string;
  // PRuebo no poner el sitio de proecsamiento id
}

export function createEmptyEquipamientoProcesamiento(): EquipamientoProcesamiento {
  return {
    id: null,
    tipo_equipamiento_procesamiento_id: null,
    tipo_movilidad_id: null,
    marca: null,
    modelo: null,
    n_precinto: null,
    gps: null,
    tipo_equipamiento_procesamiento_nombre: null
  };
}

export function createEquipamientoProcesamiento(
  params: any
): EquipamientoProcesamiento {
  return {
    ...createEmptyEquipamientoProcesamiento(),
    ...params
  };
}
